import React from 'react';

const InternalServerError = () => (
  <div className="error-message">
    <h1 className="error-info">Internal Server Error. Please contact administrator.</h1>
    <h3 className="error-more">Or retry your request later.</h3>
</div>
);

export default (InternalServerError);